import React, { Component } from 'react';
import { Sentence, TextsEditor } from './components'
import './App.css';

function pickInt(obj, key, defaultValue) {
  if (key in obj) {
    return parseInt(obj[key], 10);
  } else {
    return defaultValue;
  }
}

function triggerDownload(content, name, mime) {
  const a = document.createElement('a');
  a.setAttribute('href', `data:${mime};charset=utf-8,${encodeURIComponent(content)}`);
  a.setAttribute('download', name);
  console.log(a);

  if (document.createEvent) {
    const event = document.createEvent('MouseEvents');
    event.initEvent('click', true, true);
    a.dispatchEvent(event);
  }
  else {
      a.click();
  }
}

const Views = {
  sentence: 1,
  textsEditor: 2,
  loading: 3
}

class App extends Component {
  constructor (props) {
    super(props);
    this.playerRefs = [];
    this.playerId = -1;
    this.state = {
      players: [this.newPlayer()],
      current: 0,
      loop: false,
      playing: false,
      view: 'sentences',
      performance: false,
      focus: null
    }
  }

  componentDidMount = (e) => {
    document.addEventListener('keydown', this.handleKeyPress.bind(this));
  }
  
  newPlayer = (text = '', speed = 150, pitch = 50, volume = 100, loop = false) => {
    this.playerRefs.push(React.createRef())
    return {
      id: ++this.playerId, text, speed, pitch, volume, loop
    };
  }

  removePlayer = (k) => () => {
    this.playerRefs.splice(k, 1);
    const players = this.state.players;
    players.splice(k, 1);
    this.setState(players);
  }

  addPlayer = () => {
    const players = this.state.players;
    players.push(this.newPlayer());
    this.setState(players);
  }

  updatePlayer = (k, processor, callback) => {
    const players = this.state.players;
    players[k] = processor(players[k]);
    this.setState({ players }, callback);
  }

  handlePlayerLoopChange = (k) =>
    (loop) => this.updatePlayer(k, (player) => {
      player.loop = loop;
      return player;
    })
  
  handlePlayerPitchChange = (k) =>
    (pitch) => this.updatePlayer(k, (player) => {
      player.pitch = pitch;
      return player;
    }, this.playerRefs[k].current.updateAudio)
  
  handlePlayerSpeedChange = (k) =>
    (speed) => this.updatePlayer(k, (player) => {
      player.speed = speed;
      return player;
    }, this.playerRefs[k].current.updateAudio)
  
  handlePlayerTextChange = (k) =>
    (text) => this.updatePlayer(k, (player) => {
      player.text = text;
      return player;
    })

  handlePlayerVolumeChange = (k) =>
    (volume) => this.updatePlayer(k, (player) => {
      player.volume = volume;
      return player;
    }, this.playerRefs[k].current.updateAudio)

  handleLoopChange = () => this.setState({ loop: !this.state.loop })

  handleEnded = (k) => () => {
    if (k + 1 >= this.state.players.length) {
      if (this.state.loop) {
        this.playerRefs[0].current.play();
      } else {
        this.setState({ playing: false });
      }
    } else {
      this.playerRefs[k + 1].current.play();
    }
  }

  handlePlayerPlay = (k) => () => this.setState({ playing: true });

  handlePlayerPause = (k) => () => this.setState({ playing: false });

  handlePlayerFocus = (k) => () => {
    if (this.state.focus !== null && this.playerRefs[this.state.focus].current) {
      this.playerRefs[this.state.focus].current.closeSuggestions();
    }  
    this.setState({ focus: k })
  }

  togglePerformanceMode = () => {
    this.playerRefs.map((p) => {
      p.current.caretPosition = null
    });
    this.setState({ performance: !this.state.performance });
  }

  play = () => {
    this.playerRefs[0].current.play();
    this.setState({ playing: true });
  }

  pause = () => {
    this.playerRefs.forEach((player) => player.current.pause());
    this.setState({ playing: false });
  }

  export = () =>  {
    const data = {
      'players': []
    };

    this.state.players.forEach((v) => {
      data.players.push({
        text: v.text,
        speed: v.speed,
        loop: v.loop,
        pitch: v.pitch
      });
    });

    return data;
  }

  import = (data) => {
    this.pause();
    this.playerRefs = [];
    const players = data.players.map((v) => this.newPlayer(
      v.text,
      pickInt(v, 'speed', 150),
      pickInt(v, 'pitch', 50),
      pickInt(v, 'volume', 100),
      v.loop));

    this.setState({ players });
  }

  handleExportToJSON = () => {
    const json = JSON.stringify(this.export()),
          d = new Date(),
          name = `markovliza-${d.getFullYear()}-${d.getMonth()+1}-${d.getDate()}-${d.getHours()}${d.getMinutes()}.json`,
          mime = 'application/json';

    triggerDownload(json, name, mime)
  }

  handleExportToBash = () => {
    const bash = "#!/usr/bin/env bash\n\n" + 
      this.state.players.map((s) =>
        `espeak -a ${s.volume} -s ${s.speed} -p ${s.pitch} "${s.text}";`).join('\n')
      + `\nsleep ${window.prompt("Sleep (in minutes)", "10")}m;`;

    triggerDownload(bash, 'liza.sh', 'text/plain')
  }

  handleImport = () => {
    var input = document.createElement('input')
    input.setAttribute('type', 'file');
    input.addEventListener('change', function (e) {
      const reader = new FileReader();
      reader.onload = (e) => {
        console.log(e.target.result);
        this.import(JSON.parse(e.target.result));
      }
      reader.readAsText(input.files[0]);
    }.bind(this));

    if (document.createEvent) {
      const event = document.createEvent('MouseEvents');
      event.initEvent('click', true, true);
      input.dispatchEvent(event);
    }
    else {
      input.click();
    }
  }

  renderSentences = () => {
    const playControl = (this.state.playing) ? <button onClick={this.pause}>⏸</button> : <button onClick={this.play}>▶</button>;
    
    return <React.Fragment>
      <nav className="controls main-controls">
        <section className="control performance-hide"><button onClick={() => this.setView(Views.textsEditor)}>Edit texts</button></section>
        <section className="control"><button onClick={this.addPlayer}>+</button></section>
        <section className="control checkbox"><label><input type="checkbox" checked={this.state.loop} onChange={this.handleLoopChange} />loop</label></section>
        <section className="control">{ playControl }</section>
        <section className="control performance-hide"><button onClick={this.handleImport} title="Import a scene">Load a file</button></section>
        <section className="control performance-hide"><button onClick={this.handleExportToJSON} title="Export this scene">Save to file</button></section>
        <section className="control performance-hide"><button onClick={this.handleExportToBash} title="Export this scene to a bash script">Export for raspberry</button></section>
      </nav>
      { this.state.players.map((props, k) => <Sentence
          key={props.id}
          text={props.text}
          speed={props.speed}
          pitch={props.pitch}
          volume={props.volume}
          loop={props.loop}
          ref={this.playerRefs[k]}
          onLoopChange={this.handlePlayerLoopChange(k)}
          onPitchChange={this.handlePlayerPitchChange(k)}
          onSpeedChange={this.handlePlayerSpeedChange(k)}
          onVolumeChange={this.handlePlayerVolumeChange(k)}
          onTextChange={this.handlePlayerTextChange(k)}
          onEnded={this.handleEnded(k)}
          onRemove={this.removePlayer(k)}
          onPlay={this.handlePlayerPlay(k)}
          onPause={this.handlePlayerPause(k)}
          onFocus={this.handlePlayerFocus(k)}
        />, this)}
      </React.Fragment>
  }

  renderTextsEditor = () => {
    return <TextsEditor onClose={() => this.setView(Views.sentence)} />
  }

  renderLoading = () => {
    return 'Loading...';
  }

  setView = (view) => {
    this.setState({ view });
  }

  getView = () => {
    switch(this.state.view) {
      case Views.loading:
        return this.renderLoading();
      case Views.textsEditor:
        return this.renderTextsEditor();
      default:
        return this.renderSentences();
    }
  }

  handleKeyPress = (e) => {
    if (e.ctrlKey) {
      if (e.key == ' ' || e.key == 'p') {
        e.preventDefault();
        if (this.state.playing) {
          this.pause();
        } else {
          this.play();
        }
      }
      else if (e.key == 'm') {
        e.preventDefault();
        this.togglePerformanceMode();
      }
      else if (e.key == 's') {
        e.preventDefault();
        this.handleExportToJSON();
      }
      else if (e.key == 'e') {
        e.preventDefault();
        this.handleExportToBash();
      }
      else if (e.key == 'o') {
        e.preventDefault();
        this.handleImport();
      }
      else if (e.key == 'l') {
        e.preventDefault();
        this.setState({ loop: !this.state.loop });
      }
    }
    else if (this.state.focus !== null) {
      if (e.key === 'ArrowUp') {
        this.playerRefs[this.state.focus].current.highlightPrevSuggestion(e);
      }
      else if (e.key === 'ArrowDown') {
        this.playerRefs[this.state.focus].current.highlightNextSuggestion(e);
      }
      else if (e.key === 'Enter') {
        this.playerRefs[this.state.focus].current.pickCurrentSuggestion(e);
      }
      else if (e.key == 'Escape') {
        this.playerRefs[this.state.focus].current.closeSuggestions(e);
      }
    }
  }

  render = () => {
    return <section className="App" data-performance={this.state.performance}>
      { this.getView() }
    </section>
  }

}


export default App;



// WEBPACK FOOTER //
// ./src/App.js